import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Hero from './components/Hero';
import Features from './components/Features';
import CategorySection from './components/CategorySection';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Hero />
        <Features />
        <CategorySection />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}